<div class="header-line">
  <span class="header">
    <span class="title">Portfolio</span>
    <span class="word-separator" *ngIf="!(isLoading$ | async)">| </span> <!--HIDE ON MOBILE-->
    <span class="country-input-title">{{ (countTitle$ | async) }}</span>
  </span>
    <ng-container *ngIf="(investingEntities$ | async) as investingEntities">
      <terra-lp-asset-filter [items]="investingEntities" (onFilter)="filter($event, investingEntities)"></terra-lp-asset-filter>
    </ng-container>
</div>

<terra-loader *ngIf="(isLoading$ | async)"></terra-loader>

<div *ngIf="!(isGeneralServerError$ | async) && (numberOfHoldings$ | async) > 0" class="content" [class.hide]="isLoading$ | async">
  <ng-container *ngIf="(numberOfActiveHoldings$ | async) > 0">
    <h2 class="sub-header">Active Investments</h2>

    <div class="cards-container" *ngIf="filteredActiveInvestments.assets?.length || filteredActiveInvestments.funds?.length">
      <terra-lp-holdings-cards class="cards-group" [showAddYourAssetCard]="!isViewingAsInvestor"
                               [assets]="filteredActiveInvestments.assets" [funds]="filteredActiveInvestments.funds"></terra-lp-holdings-cards>
    </div>
  </ng-container>



    <ng-container *ngIf="filteredPendingInvestments.assets?.length || filteredPendingInvestments.funds?.length">
      <h2 *ngIf="hasPendingInvestments" class="sub-header">Pending Investments</h2>
      <div class="cards-container">
        <terra-lp-holdings-cards class="cards-group" [assets]="filteredPendingInvestments.assets"
                                 [funds]="filteredPendingInvestments.funds"></terra-lp-holdings-cards>
      </div>
    </ng-container>

    <ng-container *ngIf="filteredOpportunitiesInvestments.assets?.length || filteredOpportunitiesInvestments.funds?.length">
      <h2 *ngIf="hasOpportunitiesInvestments" class="sub-header">Opportunities</h2>
      <div class="cards-container">
        <terra-lp-holdings-cards class="cards-group" [assets]="filteredOpportunitiesInvestments.assets" [funds]="filteredOpportunitiesInvestments.funds"
                                 [isOpportunity]="true">
        </terra-lp-holdings-cards>
      </div>
    </ng-container>
</div>

<div *ngIf="!(isLoading$ | async) && (numberOfHoldings$ | async) === 0 && !(isGeneralServerError$ | async)" class="tab-empty-state">
  <img class="empty-state-image" src="assets/images/lp/empty-state-lp.svg" alt="No holdings"/>
  <div class="empty-state-lp">
    <h3>No investments here yet.</h3>
    <p>Your investment details will appear here once your investment manager publishes them.</p>
    <p>Make sure you are signed up using the email address where you received the invitation to join Covercy.</p>
  </div>
</div>

<div *ngIf="isGeneralServerError$ | async">
  <ul class="server-error-message">
    <li>Whoops!</li>
    <li>Something went wrong.</li>
    <li>Please try again later.</li>
  </ul>
</div>
